export function isInProduction() {
	return window.location.hostname.includes('partner.seznam.cz');
}
